<script>
  import { onMount } from "svelte";
  let sliderItems = [
    {
      headline: "Casey Crawford: Unseen Christmas Event",
      text:
        "Casey’s speech at Movement’s Unseen Christmas Event in December of 2020. After a year marked by adversity and uncertainty, hear how Casey responds – you certainly won’t regret it.",
      imgUrl: "https://www.youtube.com/watch?v=sJKkI1e_r68 ",
      imgSrc: "https://movement-assets.imgix.net/media/caseycrawford.com/unseen-christmas-event.png",
    },
    {
       headline: "Get to know Casey Crawford",
      text:
        "Husband. Father. Super Bowl champ. CEO. Casey believes that a business should be judged not by what it extracts from a community, but rather, by how much it gives.",
      imgUrl:
        "https://www.youtube.com/watch?v=N_kFLiQ_IpY&list=PLTNJKg0StvFfBQlYM1C48WLrYsRk3_Rzm",
      imgSrc:
        "https://movement-assets.imgix.net/media/caseycrawford.com/Get-to-know-Casey-Crawford.png",
    },
  ];

  let current = "first";
  var i = 0;

  setInterval(function () {
    if (i == 0) {
      current = "first";
    } else if (i == 1) {
      current = "second";
    } else if (i == 2) {
      current = "third";
    }

    i = i + 1;
    if (i == sliderItems.length) {
      i = 0;
    }
  }, 15000);

  onMount(function initializeCarousel() {
    var containerID = document.getElementById("slide-container");
    containerID.addEventListener("touchstart", startTouch, false);
    containerID.addEventListener("touchmove", moveTouch, false);
  });

  // Swipe Up / Down / Left / Right
  var initialX = null;
  var initialY = null;

  function startTouch(e) {
    initialX = e.touches[0].clientX;
    initialY = e.touches[0].clientY;
  }

  function moveTouch(e) {
    if (initialX === null) {
      return;
    }

    if (initialY === null) {
      return;
    }

    var currentX = e.touches[0].clientX;
    var currentY = e.touches[0].clientY;

    var diffX = initialX - currentX;
    var diffY = initialY - currentY;

    if (Math.abs(diffX) > Math.abs(diffY)) {
      if (diffX > 0) {
        // swiped left
        i = i + 1;
        if (i == sliderItems.length) {
          i = 0;
        }
        if (i == 0) {
          current = "first";
        } else if (i == 1) {
          current = "second";
        } else if (i == 2) {
          current = "third";
        }
      } else {
        // swiped right
        i = i - 1;
        if (i < 0) {
          i = 2;
        }
        if (i == 0) {
          current = "first";
        } else if (i == 1) {
          current = "second";
        } else if (i == 2) {
          current = "third";
        }
      }
    }

    initialX = null;
    initialY = null;

    e.preventDefault();
  }
</script>

<div class="flex-container">
  <div class="content-container">
    {#if current === "first" ? "active" : ""}
      <h1>{sliderItems[0].headline}</h1>
      <p>{sliderItems[0].text}</p>
    {/if}

    {#if current === "second" ? "active" : ""}
      <h1>{sliderItems[1].headline}</h1>
      <p class="second-paragraph">{sliderItems[1].text}</p>
    {/if}

    {#if current === "third" ? "active" : ""}
      <h1>{sliderItems[2].headline}</h1>
      <p>{sliderItems[2].text}</p>
    {/if}

    <div class="button-container desktop">
      <button
        class={current === "first" ? "active" : ""}
        on:click={() => (current = "first")}
      />

      <button
        class={current === "second" ? "active" : ""}
        on:click={() => (current = "second")}
      />

    </div>
  </div>

  <div id="slide-container" class="slide-container">
    {#if current === "first" ? "active" : ""}
      <div
        on:click={() => window.open(sliderItems[0].imgUrl, "_blank")}
        class="slide"
        style={`background-image: url(${sliderItems[0].imgSrc})`}
      />
    {/if}

    {#if current === "second" ? "active" : ""}
      <div
        on:click={() => window.open(sliderItems[1].imgUrl, "_blank")}
        class="slide"
        style={`background-image: url(${sliderItems[1].imgSrc})`}
      />
    {/if}

    {#if current === "third" ? "active" : ""}
      <div
        on:click={() => window.open(sliderItems[2].imgUrl, "_blank")}
        class="slide"
        style={`background-image: url(${sliderItems[2].imgSrc})`}
      />
    {/if}
  </div>

  <div class="button-container mobile">
    <button
      class={current === "first" ? "active" : ""}
      on:click={() => (current = "first")}
    />

    <button
      class={current === "second" ? "active" : ""}
      on:click={() => (current = "second")}
    />

  </div>
</div>

<style>
  button {
    display: block;
    height: 3px;
    width: 30px;
    padding: 0;
    border: none;
    background-color: #a3a6a7;
  }

  .active {
    background-color: #ff3e00;
    color: white;
    transition: width 0.5s;
    width: 50px;
  }

  .flex-container {
    display: flex;
    padding-bottom: 150px;
    margin: 0 auto;
    max-width: 1008px;
  }

  .content-container {
    width: 50%;
    justify-content: center;
    display: flex;
    flex-direction: column;
    padding-right: 25px;
    height: 257px;
    justify-content: space-between;
  }

  .content-container h1 {
    font-size: 16px;
    line-height: 1.6;
    font-weight: 600;
    text-transform: uppercase;
  }

  .content-container p {
    margin-top: 20px;
    margin-bottom: 20px;
    line-height: 1.6;
    font-size: 18px;
  }

  .button-container {
    display: flex;
    justify-content: space-between;
    width: 100px;
  }

  .button-container.mobile {
    display: none;
  }

  .slide-container {
    width: 50%;
    display: flex;
    justify-content: center;
    padding-left: 25px;
    height: 257px;
    width: 416px;
  }

  .slide {
    height: 100%;
    width: 100%;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: 50% 50%;
    position: relative;
    cursor: pointer;
  }

  @media only screen and (max-width: 1230px) {
    .flex-container {
      padding-bottom: 100px;
    }
  }

  @media only screen and (max-width: 1010px) {
    .slide-container {
      padding: 0px 50px 0px 10px;
    }
    .content-container {
      padding: 0px 10px 0px 50px;
    }
  }

  @media only screen and (max-width: 925px) {
    .content-container p {
      font-size: 15px;
    }
  }

  @media only screen and (max-width: 805px) {
    .slide-container {
      height: 166px;
      width: 270px;
    }
    .content-container {
      height: 100%;
    }
  }

  @media only screen and (max-width: 720px) {
    .flex-container {
      flex-wrap: wrap;
    }
    .content-container {
      width: 100%;
      margin-bottom: 10px;
      height: 100%;
    }
    .slide-container {
      width: 100%;
    }
    .slide {
      height: 365px;
    }
    .button-container {
      display: flex;
      justify-content: space-around;
      margin: 0 auto;
    }
    .button-container.mobile {
      display: flex;
      margin-top: 28px;
    }
    .button-container.desktop {
      display: none;
    }

    .slide-container {
      padding: 0px 50px;
    }
    .content-container {
      padding: 0px 50px;
    }
    .second-paragraph {
      margin-top: 8px !important;
      margin-bottom: 8px !important;
    }
  }

  @media only screen and (max-width: 640px) {
    .content-container p {
      font-size: 13px;
    }
  }

  @media only screen and (max-width: 520px) {
    .slide {
      height: 250px;
    }
  }
</style>
